module.exports = __webpack_public_path__ + "media/images/groupphasebet__sample@2x-a8fb65dce013ea42f1241fc7bdb983e9.png";